<mat-card appearance="outlined" class="container-fluid container">
  <form [formGroup]="workflowStageValidationForm" #form="ngForm">
    <mat-card-title class="container-header">
      <h4 class="title" mat-dialog-title *ngIf="!objectsId?.length">Valider la {{objectTypeName}} n° <strong>{{objectNumber}}</strong>
        <span *ngIf="workflowStageLevel && workflowName"> niveau
          <strong>{{workflowStageLevel}}</strong> pour le circuit de validation
          <strong>{{workflowName}}</strong>
        </span>
      </h4>
      <h4 class="title" mat-dialog-title *ngIf="objectsId?.length> 0">Validation en masse</h4>
    </mat-card-title>
    <hr class="separator">
    <mat-card-content class="container-content">

      <mat-radio-group formControlName="IsValid" *ngIf="!isWFPromotion">
        <mat-radio-button value="1" [labelPosition]="'after'">Approuver</mat-radio-button>
        <mat-radio-button value="0" [labelPosition]="'after'">Refuser</mat-radio-button>
      </mat-radio-group>

      <mat-radio-group formControlName="IsValidPromotion" *ngIf="isWFPromotion && workflowStageLevel === 1">
        <mat-radio-button value="1" [labelPosition]="'after'">Approuver</mat-radio-button>
        <mat-radio-button value="3" [labelPosition]="'after'">Renvoyer à l'opérationnel</mat-radio-button>
        <mat-radio-button value="0" [labelPosition]="'after'">Annuler la facture</mat-radio-button>
      </mat-radio-group>

      <mat-radio-group formControlName="IsValidPromotion" *ngIf="isWFPromotion && workflowStageLevel !== 1">
        <mat-radio-button value="1" [labelPosition]="'after'">Approuver</mat-radio-button>
        <mat-radio-button value="2" [labelPosition]="'after'">Renvoyer au niveau 1</mat-radio-button>
      </mat-radio-group>

      <mat-form-field appearance="outline" floatLabel="always">
        <mat-label>Commentaire</mat-label>
        <textarea matInput formControlName="Comment" matAutosizeMinRows=7 matAutosizeMaxRows=7
          [ngClass]="{ 'is-invalid': submitted && workflowStageValidationForm.errors.requiredIfIsNotValid}" style="width: 100%;height: 100px;">
        </textarea>
      </mat-form-field>

    </mat-card-content>
    <hr>
    <mat-card-footer class="container-footer">
      <div class="modal-footer d-table w-100">
        <div class="d-table-cell">
          <button type="button" mat-stroked-button class="currentBtn" data-dismiss="modal" (click)="close(false);">Annuler</button>
        </div>
        <div class="d-table-cell tar">
          <button type="submit" mat-stroked-button class="currentBtnColor" (click)="onSubmit()" [disabled]="!IsFormValid">Valider</button>
        </div>
      </div>
    </mat-card-footer>
  </form>
</mat-card>